import React, { Component } from "react";
import { connect } from "react-redux";

import { Row, Col, Modal, ModalHeader, ModalBody, Spinner } from "reactstrap";

class MRItemImages extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <React.Fragment>
        <Modal
          isOpen={this.props.modelOpen}
          backdrop="static"
          centered
          size="lg"
        >
          <ModalHeader toggle={() => this.props.modelClose()}>
            SR Item Images ({this.props.MRIImageData?.mrcodes[0]?.code})
          </ModalHeader>

          <ModalBody>
            <Row className="p-2">
              <Col md="12" className="p-1 m-0">
                {this.props.loading ? (
                  <>
                    <div className="text-center">
                      <Spinner color="primary" size="">
                        Loading...
                      </Spinner>
                    </div>
                  </>
                ) : (
                  <div
                    style={{
                      minHeight: "450px",
                    }}
                  >
                    <div className="d-inline-block mt-2 ">
                      {this.props.MRIImageData.mritemimages.length !== 0 ? (
                        <>
                          {this.props.MRIImageData.mritemimages?.map(
                            (imageURL) => (
                              <div className="product-detail mt-0 text-center d-inline-block">
                                <img
                                  src={imageURL.image}
                                  alt="..."
                                  className="product-img  img-fluid mx-auto tab-img rounded"
                                  style={{
                                    height: "150px",
                                    width: "250px",
                                  }}
                                />
                              </div>
                            )
                          )}
                        </>
                      ) : (
                        <div className="text-center">
                          <span className="font-size-18 text-danger">
                            Images not available
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </Col>
            </Row>
          </ModalBody>
        </Modal>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const { MRDetailsModel, MRRowData, loading } = state.PurchaseIndent;

  return {
    MRDetailsModel,
    MRRowData,
    loading,
  };
};

export default connect(mapStatetoProps, {})(MRItemImages);
